import { TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { Keypair, PublicKey } from "@solana/web3.js";
import Config from "../../config/settings";
// import GetOurTokenAccountsByOwnerBridgePlugin from '../../bridges/APIbridges/GetOurTokenAccountsByOwnerBridgePlugin';
import * as bip39 from "bip39";
import * as ed25519_hd_key from "ed25519-hd-key";
import { Utils } from "../../shared/utils";

export interface PrioritizationFeeObject {
    slot: number;
    prioritizationFee: number;
}

export class WalletService {

  getSolanaTokenAccountsByOwner(pubkey: string, splKey: string): Promise<Response> {
    // return fetch(Utils.selectRpcHost('constantK'), {
    //   method: 'POST',
    //   headers: {
    //     'Accept': 'application/json',
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({
    //     'jsonrpc': '2.0',
    //     'id': 1,
    //     'method': 'getTokenAccountsByOwner',
    //     'params': [
    //       pubkey,
    //       {
    //         'mint': splKey
    //       },
    //       {
    //         'encoding': 'jsonParsed'
    //       }
    //     ]
    //   }),
    // }
    // );
    return fetch(Utils.selectRpcHost('leoRPC'), {
      method: 'POST',
      headers: {
        'Accept': '*/*',
      },
      body: JSON.stringify({
        'jsonrpc': '2.0',
        'id': 1,
        'method': 'getTokenAccountsByOwner',
        'params': [
          pubkey,
          {
            'mint': splKey
          },
          {
            'encoding': 'jsonParsed'
          }
        ]
      }),
    }
    );
  }

  getSolanaCloudTokenMetadata(mints: string[]): Promise<Response> {
    return fetch(Config.solanaCloudUrl, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "addresses": mints
      }),
    }
    );
  }

  getMoralisTokenMetadata(mint: string) {

    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
        'X-API-Key': Config.apiKeyMoralis
      },
    };

    return fetch(`${Config.mainnetMoralis}/${mint}/metadata`, options);
  }

  async getAllTokensAccountsByOwner(pubkey: string) {
    return fetch(Utils.selectRpcHost('leoRPC'), {
      method: 'POST',
      headers: {
        'Accept': '*/*',
      },
      body: JSON.stringify({
        'jsonrpc': '2.0',
        'id': 1,
        'method': 'getProgramAccounts',
        'params': [
        "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        {
          "encoding": "jsonParsed",
          "filters": [
            {
              "dataSize": 165
            },
            {
              "memcmp": {
                "offset": 32,
                "bytes": pubkey
              }
            }
          ]
        }
      ]
      }),
    });
  }

  getSolanaBalance(pubkey: string): Promise<Response> {
    // return fetch(Utils.selectRpcHost('constantK'), {
    //   method: 'POST',
    //   headers: {
    //     'Accept': 'application/json',
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({
    //     'jsonrpc': '2.0',
    //     'id': 1,
    //     'method': 'getBalance',
    //     'params': [
    //       pubkey,
    //     ]
    //   }),
    // });
    return fetch(Utils.selectRpcHost('leoRPC'), {
      method: 'POST',
      headers: {
        'Accept': '*/*'
      },
      body: JSON.stringify({
        'jsonrpc': '2.0',
        'id': 1,
        'method': 'getBalance',
        'params': [
          pubkey,
        ]
      }),
    });
  }

  getRecentPrioritizationFees(): Promise<Response> {
    // return fetch(Utils.selectRpcHost("constantK"), {
    //   method: 'POST',
    //   headers: {
    //     'Accept': 'application/json',
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({
    //     'jsonrpc': '2.0',
    //     'id': 1,
    //     'method': 'getRecentPrioritizationFees',
    //   }),
    // });
    return fetch(Utils.selectRpcHost('leoRPC'), {
      method: 'POST',
      headers: {
        'Accept': '*/*'
      },
      body: JSON.stringify({
        'jsonrpc': '2.0',
        'id': 1,
        'method': 'getRecentPrioritizationFees',
      }),
    });
  }

  async getLatestBlockhash(commitment: string = 'confirmed') {
    // return fetch(Utils.selectRpcHost("constantK"), {
    //   method: 'POST',
    //   headers: {
    //     'Accept': 'application/json',
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({
    //     'jsonrpc': '2.0',
    //     'id': 1,
    //     'method': 'getLatestBlockhash',
    //     'params': [
    //       {
    //       "commitment": commitment
    //       },
    //     ]
    //   }),
    // });
    return fetch(Utils.selectRpcHost('leoRPC'), {
      method: 'POST',
      headers: {
        'Accept': '*/*'
      },
      body: JSON.stringify({
        'jsonrpc': '2.0',
        'id': 1,
        'method': 'getLatestBlockhash',
        'params': [
          {
          "commitment": commitment
          },
        ]
      }),
    });
  }

  async getOurTokenAccountsByOwner(accountPubkeyString: string) {
    return fetch(Utils.selectRpcHost('leoRPC'), {
      method: 'POST',
      headers: {
        'Accept': '*/*'
      },
      body: JSON.stringify({
        'jsonrpc': '2.0',
        'id': 1,
        'method': 'getTokenAccountsByOwner',
        'params': [
          new PublicKey(accountPubkeyString),
          {
            "programId": TOKEN_PROGRAM_ID
          },
          {
            "encoding": "jsonParsed",
            "commitment": "confirmed"
          }
        ]
      }),
    });
  }

  getSolUsdPrice() {
    return fetch('https://api.coingecko.com/api/v3/simple/price?ids=solana&vs_currencies=usd').then(
      async (result) => {
        const solResult = await result.json();
        return solResult['solana']['usd'];
      }
    );
  }

  getTokenUsdPriceChart(contract_address: string) {
    return fetch(`https://api.coingecko.com/api/v3/coins/solana/contract/${contract_address}/market_chart?vs_currency=usd&days=1&interval=daily`, { signal: AbortSignal.timeout(5000) }).then(
      async (res) => {
        const result = await res.json();
        return result;
      }
    );
  }


  getTokenInfo(contract_address: string) {
    return fetch(`https://api.coingecko.com/api/v3/coins/solana/contract/${contract_address}`, { signal: AbortSignal.timeout(5000) }).then(
      async (res) => {
        const result = await res.json();
        return result;
      }
    );
  }

  /**
   * Génération du wallet
   * @param mnemonic suite de mots clés 
   * @returns 
   */
  generateWallet(mnemonic: string) {
    let wallet: any = {};
    let master_seed = bip39.mnemonicToSeedSync(mnemonic);
    let index = 0;
    let derived_path = "m/44'/501'/" + index + "'/0'";
    let derived_seed = ed25519_hd_key.derivePath(derived_path, master_seed.toString('hex')).key;
    wallet.keypair = Keypair.fromSeed(new Uint8Array(derived_seed));
    wallet.mnemonic = mnemonic;
    wallet.publicAddress = wallet.keypair.publicKey.toBase58();
    return wallet;
  }

  /**
   * Génération de mots clés de wallet
   * @returns mnemonic
   */
  generateMnemonic(): string {
    return bip39.generateMnemonic();
  }
}